import { __extends } from "tslib";
import { deserializeAws_restJson1_1DeleteGcmChannelCommand, serializeAws_restJson1_1DeleteGcmChannelCommand } from "../protocols/Aws_restJson1_1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var DeleteGcmChannelCommand = /** @class */ (function (_super) {
    __extends(DeleteGcmChannelCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function DeleteGcmChannelCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    DeleteGcmChannelCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var handlerExecutionContext = {
            logger: {}
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    DeleteGcmChannelCommand.prototype.serialize = function (input, context) {
        return serializeAws_restJson1_1DeleteGcmChannelCommand(input, context);
    };
    DeleteGcmChannelCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_restJson1_1DeleteGcmChannelCommand(output, context);
    };
    return DeleteGcmChannelCommand;
}($Command));
export { DeleteGcmChannelCommand };
//# sourceMappingURL=DeleteGcmChannelCommand.js.map